export default function (offsetY: number) {
  if (!process.client) {
    return;
  }
  import('smooth-scroll').then((module) => {
    const instance = new module.default();
    instance.animateScroll(offsetY);
  }).catch((error) => console.error(error));
}
